import { Button } from "components/core/basic/Button";
import CenteredModal from "components/core/basic/CenteredModal";
import { trellisPalette } from "components/custom/analytics/palettes";
import { useAmazonProfiles } from "components/custom/onboarding/useAmazonProfiles";
import { useState } from "react";
import { Link, useHistory } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import { setChannel } from "redux/reducers/channel";

const AvailableProfilesModal = () => {
  const [modalDismissed, setModalDismissed] = useState(false);

  const history = useHistory();
  const channel = useAppSelector((state) => state.channel);
  const dispatch = useAppDispatch();

  const { availableRemoteProfilesData } = useAmazonProfiles(true, true);

  return availableRemoteProfilesData?.length && !modalDismissed ?
      <CenteredModal
        show={true}
        closeModal={() => {
          setModalDismissed(true);
        }}
        title={"Available Advertising Profiles"}
      >
        <p className="text-center w-75 mx-auto">
          {availableRemoteProfilesData?.length > 1 ?
            `${availableRemoteProfilesData?.length} more profiles from your Amazon Advertising account are available to connect to Trellis.`
          : "1 more profile from your Amazon Advertising is available to connect to Trellis."}{" "}
          <br />
          Visit the{" "}
          <Link
            to={{ pathname: "/user/amzsummary", state: { showProfileImportModal: true } }}
            className="fw-bold"
            style={{ color: trellisPalette[10] }}
          >
            Amazon Connect
          </Link>{" "}
          page to import them.
        </p>
        <div className="d-flex gap-5 justify-content-center pt-5">
          <Button variant="secondary" onPress={() => setModalDismissed(true)}>
            Cancel
          </Button>
          <Button
            onPress={() => {
              if (channel.currentChannel !== "amazon") {
                dispatch(setChannel("amazon"));

                localStorage.channel = "amazon";
              }
              history.push({ pathname: "/user/amzsummary", state: { showProfileImportModal: true } });
            }}
          >
            View Available Profiles
          </Button>
        </div>
      </CenteredModal>
    : null;
};

export default AvailableProfilesModal;
